import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const bomItemRowNumberSelector =
  (bomItemId: string) => (state: RootAppState) => {
    const bomItem = bomItemSelector(state, bomItemId)

    if (!bomItem?.type) {
      return null
    }

    switch (bomItem?.type) {
      case 'Row':
        return bomItem.rowNumber
      default:
        return 0
    }
  }
